import { $window } from 'util/global';

const COMPONENTS = {
    InteractiveProblem: () => import('frontend/legacy/InteractiveProblem'),
    'quizzes/QuizDropdown': () => import('frontend/legacy/quizzes/QuizDropdown'),
    'quizzes/nux/QuizNuxMain': () => import('frontend/legacy/quizzes/nux/QuizNuxMain'),
    'quizzes/endstate/QuizEndPremiumNudge': () => import('frontend/legacy/quizzes/endstate/QuizEndPremiumNudge'),
    'quizzes/endstate/QuizEndstateMain': () =>
        import('frontend/legacy/quizzes/endstate/QuizEndstateMain'),
    'assets/ContentAssetManager': () => import('frontend/legacy/assets/ContentAssetManager'),
    StreakButtonLegacyWrapper: () => import('frontend/components/StreakButtonLegacyWrapper.vue'),
    StreakButton: () => import('frontend/components/header/StreakButton.vue'),
    StreakPopup: () => import('frontend/components/header/StreakPopup.vue'),
    SearchWidget: () => import('frontend/components/search/SearchWidget'),
    ReferralHistoryModal: () => import('frontend/views/referral/components/ReferralHistoryModal'),
    ReferAFriendModal: () => import('frontend/views/referral/components/ReferAFriendModal'),
    SubscriptionSettingsModal: () => import('frontend/legacy/SubscriptionSettingsModal'),
};

function importComponent(componentName) {
    const cmp = COMPONENTS[componentName];
    if (cmp) {
        return cmp();
    }
    throw new Error(`Unknown component '${componentName}'`);
}

/**
 * Loads a "legacy" Vue component and mounts to the $container element.
 * @param {JQuery} $container
 * @usage
    <div
      data-controller="app/vue:component"
      data-component="ExampleComponent"
      data-my-property="example">
    </div>

    This example is loading frontend/legacy/ExampleComponent.vue and passing `myProperty` as a Vue
    component prop.

    All data attributes will be passed as props to the component, and the component can ignore
    props it doesn't need. Prop type checking will work for any type that is automatically parsed
    by `$.data` (i.e. "example" => string, "10" => number, "[1,2,3]" => Array).

    Legacy components can trigger events (and pass data to the rest of the JS) using the `$emit`
    function:
      $emit('external', {
        name: 'myevent',
        otherProp: true,
      })

    To listen for the event:
      $window.on('MyComponent.myevent', (e, data) => {
        console.log(data.otherProp);
      });
 */
export function component($container, additionalProps = {}) {
    const props = $container.data();
    importComponent(props.component).then((module) => {
        const Component = module.default;
        const cmp = new Component({
            propsData: {
                ...props,
                ...additionalProps,
            },
        });
        cmp.$mount($container[0]);
        cmp.$on('external', (e) => {
            if (e.name) {
                // Example full event name: 'MyComponent.submitForm'
                $window.trigger(`${props.component}.${e.name}`, e);
            }
        });
    });
}
